import _ from 'lodash'
import { createProduct, deleteProduct, updateProduct, updateSections } from '../../apis/backend'
import {
  displayPriceFormat,
  isIntegerNotNull,
  isObjectNotEmpty,
  keyGenerator,
  removeUndefinedProperties
} from '../../utils/tools'
import { getFirstProductCategory, setCopyKey, sortItemsPositionForShop } from '../../utils/product'
import defaultImg from '../../assets/pictures/no_image.jpeg'
import {
  ERROR_DUPLICATION,
  ERROR_EMPTY_OPTION_LIST,
  ERROR_PRICE,
  ERROR_PRODUCT_PRICE,
  ERROR_SYNCHRONIZATION_WITH_SHOP,
  ERROR_UPDATE_PRODUCT,
  ERROR_WRONG_INFORMATIONS,
  ORDER_TYPE_COLLECT,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_SEAT,
  SPLASH,
  SUITABLE_ORDER_TYPES
} from '../../constants'
import { getShopsToSynchronise } from '../../utils/shopUtils'
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration'
import { getCroppedImg } from 'src/utils/image'
import { checkAccess } from 'src/utils/admins'

const CATEGORY_SEPARATOR = ',';

const closeDeleteModal = component => {
  const { showModal } = component.props;
  component.setState({ synchronize: false, isSuppression: false, selectedShops: {} });
  showModal(false);
};
export const handleRemoveProduct = (product, component) => {
  const { showModal, shopId, shops, nbShops } = component.props;
  const { name, key } = product;
  const nbShopsToSync = _.size(getShopsToSynchronise())
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer le produit ${name.toLowerCase()} ?`,
    showCancelBtn: true,
    checkboxes: nbShops > 1 && nbShopsToSync > 1 && checkAccess('features', 'globalProduct') ?
      [{
        text: 'Supprimer ce produit sur un ou plusieurs magasins',
        onChange: checked => {
          component.setState({ synchronize: checked });
        }
      }] : [],
    handleClose: () => {
      closeDeleteModal(component);
    },
    btnColor: 'danger',
    onClick: () => {
      component.state.synchronize && nbShops > 1 && nbShopsToSync > 1 ?
        component.setState({
          selectedShops: { [shopId]: shops[shopId] },
          showModal: true,
          productKey: key
        }) :
        handleRemoveProductSubmit(key, component);
      showModal({
        ...modalData,
        loading: true
      });


    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
};

export const handleRemoveProductSubmit = async (productKey, component) => {
  const { openErrorModal, sections = {}, sectionKey } = component.props;
  const { synchronize = false, selectedShops } = component.state;
  const { key = '' } = sections[sectionKey];
  try {
    component.setState({ removeProductModal: false });
    if (!synchronize || (synchronize && _.size(selectedShops) > 1)) {
      component.setState({ isLoadingProduct: true })
      await deleteProduct(productKey, key, synchronize, selectedShops);
      await component.setState({ isSuppression: false, showModal: false, isLoadingProduct: false, isLoading: true });
      await closeDeleteModal(component)
    }

    else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoadingProduct: false }) };


  } catch (error) {
    await component.setState({ isSuppression: false, showModal: false, isLoadingProduct: false });
    await closeDeleteModal(component)
    openErrorModal(ERROR_UPDATE_PRODUCT);

  }
};

export const returnImage = image => {
  return image || defaultImg;
};
const cleanSection = (section) => {
  if (!section.products) return section;

  const cleanProducts = {};
  let index = 0;
  Object.keys(section.products).forEach(productKey => {
    const product = section.products[productKey];
    if (product.key) {
      cleanProducts[productKey] = {
        ...product,
        position: typeof product.position === 'number' ? product.position : index
      };
      index++;
    }
  });

  return {
    ...section,
    products: cleanProducts
  };
};
export const handleDragProduct = async (event, products, component) => {
  const { openErrorModal, sectionKey, handleStateChange, sections, shopId } = component.props;
  const { currentSectionKey, isUpdating } = component.state;
  const { active, over } = event;

  if (isUpdating) {
    return;
  }

  component.setState({ isDragging: false, isUpdating: true });

  if (active && over) {
    handleStateChange({ currentSectionKey: null, highlightSection: {} });
    try {
      const updatedSections = JSON.parse(JSON.stringify(sections));

      if (currentSectionKey && currentSectionKey !== sectionKey) {
        handleStateChange({ expanded: currentSectionKey });

        const sourceProduct = updatedSections[sectionKey].products[active.id];

        if (!sourceProduct || !sourceProduct.key || !active.id) {
          return
        }

        delete updatedSections[sectionKey].products[active.id];

        if (!updatedSections[currentSectionKey]) {
          updatedSections[currentSectionKey] = { products: {} };
        }


        if (!updatedSections[currentSectionKey].products) {
          updatedSections[currentSectionKey].products = {};
        }


        updatedSections[currentSectionKey].products[active.id] = {
          ...sourceProduct
        };
      }

      const cleanedSections = {};
      _.keys(updatedSections).forEach(sKey => {
        cleanedSections[sKey] = cleanSection(updatedSections[sKey]);
      });

      await updateSections(cleanedSections);

      if (active.id !== over.id) {
        component.setState({
          activeId: null,
        });

        await sortItemsPositionForShop(event, products, sectionKey, false, true, shopId);

      }
    } catch (error) {
      console.error(error);
      openErrorModal(ERROR_UPDATE_PRODUCT);
    } finally {
      component.setState({ isUpdating: false });
    }
  } else {
    component.setState({ isUpdating: false });
  }
};

export const updateAvailableProduct = async (productKey, product, component) => {
  const { sectionKey, openErrorModal } = component.props;
  try {
    product.disabled = !product.disabled;
    await updateProduct(product, sectionKey, productKey);
  } catch (err) {
    openErrorModal(ERROR_UPDATE_PRODUCT);
  }
};

export const getMinimumPriceFreeProduct = product => {
  let minPrice = null;
  const firstShopCategory = getFirstProductCategory(product);
  if (firstShopCategory) {
    _.map(firstShopCategory.items, item => {
      if (item) {
        const { price } = item;
        if (!minPrice || price < minPrice) {
          minPrice = price;
        }
      }
    });
  }
  return displayPriceFormat(minPrice);
};

export const handleNewProduct = (e, sectionKey, component) => {
  e.stopPropagation();
  component.setState({
    productModalOpen: true,
    sectionKey,
    croppedImage: {},
    product: {},
    categoriesArray: [],
    disabledOrderTypes: []
  });
};

export const handleSubmitProduct = async (component, shopsMenu, selectedCategories) => {
  const {
    product,
    categoriesArray = [],
    productModalOpen,
    synchronize = false,
    disabledOrderTypes
  } = component.state;
  const { openErrorModal, sectionKey, sections, categories } = component.props;
  const {
    name,
    description,
    stock = null,
    ref = '',
    price,
    preparationTime = null,
    disabled = false,
  } = product;
  let { position } = product;
  const categoriesString = categoriesArray
    .filter(category => category?.key)
    .map(({ key }) => key.split(CATEGORY_SEPARATOR)[0].trim())
    .filter(Boolean)
    .join(CATEGORY_SEPARATOR);
  position = productModalOpen
    ? parseInt(sections[sectionKey].products ? _.size(sections[sectionKey].products) : 0, 10)
    : parseInt(position, 10);
  const nameToCkeck = name ? name.replace(/\s+/g, '') : '';
  const hasInvalidCategories =
    _.size(categoriesArray) < _.size(selectedCategories) &&
    checkIntegrationAccess('products', 'disableOptionList');
  const hasInvalidPrice = canUseSplashPrice(product) && parseFloat(price) > parseFloat(product?.priceRef);

  const hasEmptyOptionList = categoriesArray.some(category => {
    const [categoryKey] = category?.key?.split(CATEGORY_SEPARATOR) ?? [];

    if (!categoryKey) {
      return false
    };

    const categoryData = categories?.[categoryKey];
    if (!categoryData) {
      return false;
    }

    const items = categoryData.items;
    return !items || _.isEmpty(items);
  });

  if (hasInvalidPrice) {
    openErrorModal(`${ERROR_PRICE} ${product?.priceRef} €`)
    return;
  }
  if (hasInvalidCategories) {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
    return;
  }
  if (hasEmptyOptionList) {
    openErrorModal(ERROR_EMPTY_OPTION_LIST);
    return;
  }
  if (
    nameToCkeck &&
    nameToCkeck.length > 0 &&
    parseFloat(price) >= 0 &&
    position >= 0 &&
    (ref !== '' || !hasExternalIntegration())
  ) {
    try {
      component.setState({
        isLoadingProduct: true
      });
      const renderProduct = removeUndefinedProperties({
        ...product,
        name,
        price: parseFloat(price),
        priceRef: hasExternalIntegration() === SPLASH ? price : null,
        stock,
        position,
        categories: categoriesString,
        key: productModalOpen ? keyGenerator('PRODUCT') : product.key,
        description,
        disabled,
        sectionName: null,
        preparationTime: isIntegerNotNull(preparationTime) ? parseInt(preparationTime, 10) : '',
        disabledDelivery: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_DELIVERY]),
        disabledCS: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_SEAT]),
        disabledCC: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_COLLECT])
      });

      const imageConfig = product?.imageConfig
      if (imageConfig) {
        const croppedImageUrl = await getCroppedImg(imageConfig.imageUrl, imageConfig.croppedAreaPixels);
        renderProduct['image64'] = croppedImageUrl.split(',')[1];
        if (imageConfig?.hasUserEdited) {
          renderProduct.image = null;
          renderProduct.imageCompressed = null;
        }
        renderProduct.imageConfig = null;
      } else {
        renderProduct.image = '';
        renderProduct.imageCompressed = ''
      }

      for (const i in renderProduct) {
        if (renderProduct[i] === null) {
          delete renderProduct[i];
        }
      }

      if (!synchronize || (synchronize && _.size(shopsMenu) > 1)) {
        if (productModalOpen) {
          await createProduct(renderProduct, sectionKey, Object.keys(shopsMenu || {}))
        } else {
          await updateProduct(renderProduct, sectionKey, renderProduct.key, Object.keys(shopsMenu || {}))
        }
        component.setState({
          updateProductModalOpen: false,
          productModalOpen: false,
          isLoadingProduct: false,
          synchronize: false,
          showModal: false,
          disabledOrderTypes: []
        });
      }

      else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoadingProduct: false }) };

    } catch (err) {


      const errorMessage = err?.message || '';
      if (errorMessage.includes('could not exceed 0')) {
        openErrorModal(ERROR_PRODUCT_PRICE);
      } else {
        openErrorModal(ERROR_UPDATE_PRODUCT);
      }
    }
  } else {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
  }



  component.setState({
    isLoadingProduct: false, selectedShops: {}
  });
}



export const handleDuplicateProduct = async (product, component) => {
  const { openErrorModal, sectionKey } = component.props;
  const newProduct = { ...product, key: setCopyKey(keyGenerator('PRODUCT')), sectionName: undefined };
  try {
    await createProduct(newProduct, sectionKey);
  } catch (err) {
    openErrorModal(ERROR_DUPLICATION);
  }
}

export const addOption = (name, key, itemIndex, component) => {
  component.setState(prevState => {
    const { categoriesArray } = prevState;
    if (itemIndex > -1) categoriesArray.splice(itemIndex, 1);
    else
      categoriesArray.push({
        name,
        key
      });
    return { categoriesArray };
  });
}

export const handleChangeOrderTypes = ({ target }, component) => {
  const { value } = target;
  component.setState({
    disabledOrderTypes: value
  });
}

export const getDisabledOrderTypes = product => {
  const { disabledDelivery = false, disabledCC = false, disabledCS = false } = product;
  const disabledOrderTypes = [];
  if (disabledDelivery) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_DELIVERY]);
  if (disabledCS) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_SEAT]);
  if (disabledCC) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_COLLECT]);
  return disabledOrderTypes;
};
export const handleProduct = (categoriesArray, product, component) => {
  const { name = '' } = product;
  component.setState({
    updateProductModalOpen: true,
    categoriesArray,
    product,
    productName: name,
    disabledOrderTypes: getDisabledOrderTypes(product)
  });
}

export const handleChange = ({ target }, component) => {
  component.setState(prevState => ({
    product: { ...prevState.product, [target.id]: target.value }
  }));
}

export const handleChangeNumber = ({ target }, component) => {
  const { value, id } = target;
  component.setState(prevState => ({
    product: { ...prevState.product, [id]: value >= 0 ? value : 0 }
  }));
}

export const handleRemoveImage = component => {
  component.setState(prevState => ({
    product: { ...prevState.product, image: '', image64: '', imageConfig: null }
  }));
}

export const setCroppedImage = async (croppedImage, component) => {
  component.setState(prevState => ({
    product: { ...prevState.product, image64: croppedImage.split(',')[1] }
  }));
}

export const setImageConfig = async (configObject, component) => {
  component.setState(prevState => ({
    product: { ...prevState.product, imageConfig: configObject }
  }));
};

export const handleStartDrag = (event, component) => {
  component.setState({ activeId: event.active.id, isDragging: true });
}

export const handleDragMove = (event, component) => {
  const { sections, handleStateChange, sectionKey } = component.props;
  const { currentSectionKey } = component.state;
  if (component.state.isDragging) {
    document.addEventListener('mousemove', (event) => handleMouseMove(event, component));
    document.addEventListener('touchmove', (event) => handleMouseMove(event, component));
    if (currentSectionKey) {
      handleStateChange({ highlightSection: currentSectionKey !== sectionKey ? sections[currentSectionKey] : {} });
    }
  }
};

export const handleMouseMove = (event, component) => {
  if (!component.isProcessingMouseMove && component.state.isDragging) {
    component.isProcessingMouseMove = true;
    requestAnimationFrame(() => {
      const mouseX = event.clientX || (event.touches && event.touches[0].clientX);
      const mouseY = event.clientY || (event.touches && event.touches[0].clientY);
      const sections = document.querySelectorAll('.section');
      sections.forEach(section => {
        const sectionRect = section.getBoundingClientRect();
        const sectionKey = section.getAttribute('data-section-key');
        if (
          mouseX >= sectionRect.left &&
          mouseX <= sectionRect.right &&
          mouseY >= sectionRect.top &&
          mouseY <= sectionRect.bottom
        ) {
          if (component.state.mounted) {
            component.setState({ currentSectionKey: sectionKey })
          }
        }
      });
      component.isProcessingMouseMove = false;
    });
  }
};
export const canUseSplashPrice = (product) => {
  return hasExternalIntegration() === SPLASH && isObjectNotEmpty(product) && product?.ref !== '$'
}








